import React, { useState } from 'react';

const advantages = [
  {
    id: 1,
    icon: '/images/icons/trophy.webp',
    frontNumber: '6000+',
    frontTitle: 'МАГАЗИНОВ',
    backTitle: 'ОПЫТ И ЭФФЕКТИВНОСТЬ',
    backText: 'Запустили более 6000 магазинов с 2020 года. Это больше, чем любая клиентская база наших конкурентов.',
    iconRotate: -8,
  },
  {
    id: 2,
    icon: '/images/icons/shield.webp',
    frontNumber: '100%',
    frontTitle: 'ГАРАНТИЯ',
    backTitle: 'СТАБИЛЬНО И НАДЁЖНО',
    backText: 'Даём юридические и финансовые гарантии выполнения своих обязательств по договору.',
    iconRotate: 6,
  },
  {
    id: 3,
    icon: '/images/icons/chart.webp',
    frontNumber: '24/7',
    frontTitle: 'КОНТРОЛЬ',
    backTitle: 'КОНТРОЛЬ НА ВСЕХ ЭТАПАХ',
    backText: 'Team-lead контролирует качество работы для соблюдения результата роста магазина.',
    iconRotate: -5,
  },
  {
    id: 4,
    icon: '/images/icons/rocket.webp',
    frontNumber: '360°',
    frontTitle: 'ПОД КЛЮЧ',
    backTitle: 'КОМПЛЕКСНЫЙ ПОДХОД',
    backText: 'От создания карточки, фото и видео до запуска рекламных интеграций с блогерами.',
    iconRotate: 7,
  },
  {
    id: 5,
    icon: '/images/icons/wallet.webp',
    frontNumber: '0',
    frontTitle: 'СКРЫТЫХ ПЛАТЕЖЕЙ',
    backTitle: 'РАБОТАТЬ С НАМИ ВЫГОДНО',
    backText: 'Фиксированная цена, прописанная в договоре. Никаких скрытых платежей и доплат.',
    iconRotate: -6,
  },
  {
    id: 6,
    icon: '/images/icons/star.webp',
    frontNumber: 'ТОП-10',
    frontTitle: 'АГЕНТСТВ',
    backTitle: 'ДОРОЖИМ РЕПУТАЦИЕЙ',
    backText: 'Работаем с гигантами рынка, качество подтверждено рекомендательными письмами.',
    iconRotate: 5,
  },
];

const FlipCard = ({ item }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className="whyus-card"
      onClick={() => setFlipped(prev => !prev)}
      onMouseEnter={() => setFlipped(true)}
      onMouseLeave={() => setFlipped(false)}
      style={{
        position: 'relative',
        height: '220px',
        cursor: 'pointer',
      }}
    >
      {/* Иконка — поверх карточки, в правом нижнем углу */}
      <img
                loading="lazy"
        src={item.icon}
        alt=""
        style={{
          position: 'absolute',
          width: '80px',
          height: '80px',
          bottom: '-10px',
          right: '16px',
          zIndex: 5,
          objectFit: 'contain',
          transform: `rotate(${item.iconRotate}deg)`,
          filter: 'drop-shadow(0 8px 20px rgba(0,0,0,0.4))',
          opacity: flipped ? 0 : 1,
          transition: 'opacity 0.4s ease, transform 0.4s ease',
          pointerEvents: 'none',
        }}
      />

      {/* Контейнер карточки */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        {/* FRONT */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            padding: '28px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            opacity: flipped ? 0 : 1,
            transform: flipped ? 'scale(0.95)' : 'scale(1)',
            transition: 'opacity 0.4s ease, transform 0.4s ease',
            pointerEvents: flipped ? 'none' : 'auto',
            zIndex: flipped ? 1 : 2,
          }}
        >
          <div>
            <div
              style={{
                fontSize: '52px',
                fontWeight: 800,
                background: 'linear-gradient(135deg, #22D3EE 0%, #8B5CF6 50%, #EC4899 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                lineHeight: 1,
                marginBottom: '6px',
              }}
            >
              {item.frontNumber}
            </div>
            <div
              style={{
                fontSize: '15px',
                fontWeight: 600,
                color: '#FFFFFF',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              {item.frontTitle}
            </div>
          </div>

          <div
            style={{
              fontSize: '12px',
              color: 'rgba(255, 255, 255, 0.3)',
            }}
          >
            нажмите →
          </div>
        </div>

        {/* BACK */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '20px',
            background: 'linear-gradient(135deg, rgba(34, 211, 238, 0.15) 0%, rgba(139, 92, 246, 0.15) 50%, rgba(236, 72, 153, 0.15) 100%)',
            border: '1px solid rgba(34, 211, 238, 0.3)',
            padding: '28px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            opacity: flipped ? 1 : 0,
            transform: flipped ? 'scale(1)' : 'scale(0.95)',
            transition: 'opacity 0.4s ease, transform 0.4s ease',
            pointerEvents: flipped ? 'auto' : 'none',
            zIndex: flipped ? 2 : 1,
          }}
        >
          <h3
            style={{
              fontSize: '18px',
              fontWeight: 700,
              color: '#FFFFFF',
              textTransform: 'uppercase',
              margin: '0 0 12px 0',
              lineHeight: 1.2,
            }}
          >
            {item.backTitle}
          </h3>
          <p
            style={{
              fontSize: '14px',
              fontWeight: 400,
              color: 'rgba(255, 255, 255, 0.8)',
              lineHeight: 1.6,
              margin: 0,
            }}
          >
            {item.backText}
          </p>
        </div>
      </div>
    </div>
  );
};

const WhyUsSection = () => {
  return (
    <section
      className="whyus-section"
      style={{
        background: '#0F0F1A',
        padding: '80px 0 100px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные иконки на фоне */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
        <img loading="lazy" src="/images/icons/star.webp" alt="" className="whyus-bg-icon whyus-bg-1" />
        <img loading="lazy" src="/images/icons/trophy.webp" alt="" className="whyus-bg-icon whyus-bg-2" />
        <img loading="lazy" src="/images/icons/shield.webp" alt="" className="whyus-bg-icon whyus-bg-3" />
        <img loading="lazy" src="/images/icons/wallet.webp" alt="" className="whyus-bg-icon whyus-bg-4" />
      </div>

      <div
        style={{
          maxWidth: '1100px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Заголовок */}
        <div className="whyus-header" style={{ display: 'flex', alignItems: 'center', gap: '24px', marginBottom: '56px', flexWrap: 'wrap' }}>
          <span
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              color: '#FFFFFF',
              fontSize: '14px',
              fontWeight: 500,
              padding: '12px 24px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            ПОЧЕМУ МЫ
          </span>
          <h2
            className="whyus-title"
            style={{
              fontSize: '36px',
              fontWeight: 800,
              color: '#FFFFFF',
              textTransform: 'uppercase',
              lineHeight: 1.2,
              margin: 0,
            }}
          >
            ПЕРВЫЙ СЕЛЛЕР ВСЕГДА ДОСТИГАЕТ РЕЗУЛЬТАТА
          </h2>
        </div>

        {/* Сетка карточек */}
        <div className="whyus-grid">
          {advantages.map(item => (
            <FlipCard key={item.id} item={item} />
          ))}
        </div>
      </div>

      <style>{`
        .whyus-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 28px;
        }

        /* Фоновые иконки */
        .whyus-bg-icon {
          position: absolute;
          opacity: 0.05;
          filter: blur(1px) grayscale(0.3);
        }
        .whyus-bg-1 { width: 100px; height: 100px; top: 8%; left: 5%; animation: floatWhy1 6s ease-in-out infinite; }
        .whyus-bg-2 { width: 100px; height: 100px; top: 12%; right: 6%; animation: floatWhy2 7s ease-in-out infinite; }
        .whyus-bg-3 { width: 100px; height: 100px; bottom: 25%; left: 7%; animation: floatWhy3 5.5s ease-in-out infinite; }
        .whyus-bg-4 { width: 100px; height: 100px; bottom: 20%; right: 5%; animation: floatWhy4 6.5s ease-in-out infinite; }

        @keyframes floatWhy1 {
          0%, 100% { transform: translate(0, 0) rotate(-12deg); }
          50% { transform: translate(-10px, -15px) rotate(-12deg); }
        }
        @keyframes floatWhy2 {
          0%, 100% { transform: translate(0, 0) rotate(10deg); }
          50% { transform: translate(10px, -20px) rotate(10deg); }
        }
        @keyframes floatWhy3 {
          0%, 100% { transform: translate(0, 0) rotate(15deg); }
          50% { transform: translate(-15px, -10px) rotate(15deg); }
        }
        @keyframes floatWhy4 {
          0%, 100% { transform: translate(0, 0) rotate(-8deg); }
          50% { transform: translate(15px, -15px) rotate(-8deg); }
        }

        @media (max-width: 1024px) {
          .whyus-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .whyus-bg-icon { display: none !important; }
        }
        @media (max-width: 768px) {
          .whyus-section { padding: 50px 0 60px !important; }
          .whyus-header { flex-direction: column !important; align-items: flex-start !important; gap: 12px !important; margin-bottom: 32px !important; }
          .whyus-title { font-size: 26px !important; }
          .whyus-card { height: 200px !important; }
        }
        @media (max-width: 640px) {
          .whyus-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) {
          .whyus-section { padding: 40px 0 50px !important; }
          .whyus-title { font-size: 22px !important; }
          .whyus-card { height: 180px !important; }
        }
      `}</style>
    </section>
  );
};

export default WhyUsSection;
